import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_UPDATE_VEHICLE_DESCRIPTION = `${VEHICLE_MODULE_PREFIX}_UPDATE_VEHICLE_DESCRIPTION`;
export const onUpdateVehicleDescriptionAction = (payload) => ({
    type: VEHICLE_UPDATE_VEHICLE_DESCRIPTION,
    payload
});
//# sourceMappingURL=updateVehicleDescriptionAction.js.map